import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { GenericActionsComponent } from './generic-actions.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  declarations: [GenericActionsComponent],
  exports: [GenericActionsComponent]
})
export class GenericActionsModule { }
